import React, { memo, useCallback, useMemo, useState } from 'react';
import { Button } from 'shards-react';
import ConfirmModal from '../../ConfirmModal';

const ReactivateDocument = ({ reactivationHandler }) => {
	const [confirmOverlay, setConfirmOverlay] = useState(false);

	const toggleConfirm = useCallback(() => setConfirmOverlay((oldState) => !oldState), []);

	const toggleButton = useMemo(
		() => (
			<Button pill theme='success' onClick={toggleConfirm}>
				<i className='fas fa-undo mr-2 align-middle' style={{ fontSize: 'large' }} />
				<span className='align-middle'>Dokument reaktivieren</span>
			</Button>
		),
		[toggleConfirm]
	);

	return (
		<React.Fragment>
			{toggleButton}
			{confirmOverlay && <ConfirmModal message={'Möchten Sie das ausgewählte Dokument reaktivieren?'} confirmFunction={() => reactivationHandler(toggleConfirm)} closeModal={toggleConfirm} />}
		</React.Fragment>
	);
};

export default memo(ReactivateDocument);
